import originAxios from 'axios'
import { TIMEOUT, TIMEOUT_MESSAGE, TIMEOUT_UPLOAD } from 'common/const.js'
import { DATA_ACCESS, CHIAVI_ORACOLO } from './url.js'

const JsonType = 'application/json; charset=utf-8'
const TextType = 'text/plain'

function setInterceptors (instance, contentType) {
  // 1. Set interceptors of request
  instance.interceptors.request.use(config => {
    // Loading animation in request
    // Add header to all request
    config.headers['Content-Type'] = contentType

    // convert data to string
    if (config.data !== undefined) {
      config.data = JSON.stringify(config.data)
    }

    // return config
    return config
  }, err => {
    return Promise.reject(err)
  })

  // 2. Set interceptors of response
  instance.interceptors.response.use(response => {
    return response.data
  }, err => {
    if (err && err.response.status === 404) {
      err.message = 'Not Found'
    }
    return Promise.reject(err)
  })

  return instance
}

// Request to Data Access
export function requestDataAccess (config) {
  let instance = originAxios.create({
    baseURL: DATA_ACCESS,
    timeout: TIMEOUT,
    timeoutErrorMessage: TIMEOUT_MESSAGE
  })

  instance = setInterceptors(instance, JsonType)
  return instance(config)
}

// Request to Chiavi Oracolo
export function requestChiaviOracolo (config) {
  let instance = originAxios.create({
    baseURL: CHIAVI_ORACOLO,
    timeout: TIMEOUT
  })

  instance = setInterceptors(instance, JsonType)
  return instance(config)
}

// Request GCP
export function requestGCP (config, url) {
  let instance = originAxios.create({
    baseURL: url,
    timeout: TIMEOUT_UPLOAD
  })

  instance = setInterceptors(instance, TextType)
  return instance(config)
}
